import { Box, useTheme } from '@mui/material'
import { motion } from 'framer-motion'

const AnimatedProgressBar = ({
  progress,
  color,
  orientation = 'horizontal',
}: {
  progress: number
  color?: string
  orientation?: string
}) => {
  const theme = useTheme()

  return orientation === 'horizontal' ? (
    <Box
      sx={{
        width: '100%',
        maxWidth: 600,
        backgroundColor: theme.palette.divider,
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: 'none',
        position: 'relative',
      }}
    >
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        style={{
          height: 20,
          backgroundColor: color ?? theme.palette.primary.main,
        }}
      />
    </Box>
  ) : (
    <Box
      sx={{
        height: `${progress}px`,
        minHeight: 2,
        backgroundColor: theme.palette.divider,
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: 'none',
        position: 'relative',
      }}
    >
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: '100%' }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        style={{
          height: 20,
          backgroundColor: color ?? theme.palette.primary.main,
        }}
      />
    </Box>
  )
}

export default AnimatedProgressBar
